<ng-container *ngFor="let error of errors">
  <span *ngIf="error.invalid"
        class="help-block"> {{ error.message }} </span>
</ng-container>